import { useLinesDetailMovieStore } from "@/stores/LinesDetailMovie";
import { useDetailPageStore } from "@/stores/DetailPage";
import { type RouteLocationNormalized } from 'vue-router';

const {
	setCurrentItemDetail
} = useDetailPageStore();

const {
    fetchCast,
    fetchRelatedContent,
	clearAllLinesDetailMovie
} = useLinesDetailMovieStore();


export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	if (import.meta.client) {
		clearAllLinesDetailMovie();

		setCurrentItemDetail(to.params.id as string);

		void fetchCast();

		void fetchRelatedContent();
	}
});